import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { AlertService } from 'src/app/alert-notify/alert-notify.service';
import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';



@Component({
    selector: 'app-ecitation-muni-status',
    templateUrl: './ecitation-muni-status.component.html',
    styleUrls: ['./ecitation-muni-status.component.css'],
    standalone: false
})
export class EcitationMuniStatusComponent implements OnInit {
  private subcription: Subscription;
  selectedTab = 'all';
  showDetailTable = false;
  muniStatus: any;
  muniQueueSummary: any = [];
  selectedCount: any;
  selectedForPurge: any = [];
  userTypeView:any;
  sortName= '';
  sortDir='';
  details: any = { Q: 'Queued', F: 'Failed', R: 'Rejected', D: 'Delivered' }
  alert: any

  constructor(private ecitationUserService: EcitationUserService,
     public alertService: AlertService,
     public authService: AuthService,
     private router:Router) {
    this.subcription = this.ecitationUserService.reloadComponent1$.subscribe(() => {
      this.selectedTab = 'all';

      this.currentPage = 1;
      this.currentPage2 =1;
      if (this.showDetailTable) {
        this.showDetailTable = false;
      }
      this.getData();
    })

  }

  ngOnInit(): void {
    this.userTypeView = this.authService.getUserType();
    this.getData();
  }

  ngOnDestroy() {
    this.subcription.unsubscribe();
  }

  tableHeaders = [
    { header: 'Court #', value: 'courtNumber', isSortable: true },
    { header: 'Name', value: 'courtName', isSortable: true },
    { header: 'Vendor', value: 'vendorName', isSortable: false },
    { header: 'Total', value: 'totalCount', isSortable: false },
    { header: 'Queued', value: 'queuedCount', isSortable: false },
    { header: 'Oldest', value: 'oldest', isSortable: false },

  ]

  tableData: any = [

  ]
  pageSize: number = 25;
  currentPage: number = 1;
  currentPage2:number =1

  getItems() {
    return this.tableData.content;
  }

  getItems2() {
    return this.muniQueueSummary.content;
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.getQueueSummary(this.sortName,this.sortDir)
  }

  onPageChange2(pageNumber: number) {
    this.currentPage2 = pageNumber;
    this.showDetails({ courtNumber: this.selectedCount });
  }

  getTotalPages(): number {
    return this.tableData.totalPages;
  }


  getVisiblePages(): number[] {
    const totalVisiblePages = 10;
    const visiblePages: number[] = [];
    const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
    const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i)
    }
    return visiblePages
  }


  onSort(event: any, name: any, isSortable: boolean) {
    if (isSortable) {
      let spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target,
        classList = spanEle.classList;
      let sortDir = 1;
      if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
        classList.remove('fa-sort')
        classList.remove('fa-sort-up')
        classList.add('fa-sort-down')
        sortDir = -1
      } else {
        classList.add('fa-sort-up')
        classList.remove('fa-sort-down')

      }
      this.sortBy(name, sortDir)
    }
  }

  sortBy(name: string, order: number) {
    var orderVal = order ==1?'asc':'desc';
    this.sortName = name;
    this.sortDir= orderVal;
    this.getQueueSummary(name,orderVal)
  }

  getData() {

    this.ecitationUserService.getMuniStatus().subscribe((data) => {
      this.muniStatus = data;
    })
  }

  getQueueSummary(name:any = '',dec:any ='') {
    const prePrams = { page:this.currentPage-1,
      size:this.pageSize,
      sort:name !== ''?`${name},${dec}`:''
    }
    const postParam = this.generateParams(prePrams)
    this.ecitationUserService.getMuniQueueSummary(postParam).subscribe((data) => {
      this.tableData = data;
    })
  }

  showDetails(data: any,name:any = '',dec:any ='') {
    this.selectedCount = data.courtNumber;
    const prePrams = { page:this.currentPage2-1,
      size:this.pageSize,
      sort:name !== ''?`${name},${dec}`:'',
      courtNumber:data.courtNumber
    }
      const postParam = this.generateParams(prePrams)
    this.ecitationUserService.getMuniQueueDetails(postParam).subscribe((data:any) => {
      this.showDetailTable = true;
      this.currentPage = 1;
      this.muniQueueSummary = data;
      this.muniQueueSummary.content.forEach((element: any, i: any) => {
        element.id = `muni-${this.currentPage2}-${i}`
        element.checked = false
      });
    })
  }
  isSelected(item:any){
    return this.selectedForPurge.some((r:any) => r.id === item.id)
  }toggleSelection(item:any){
    const index = this.selectedForPurge.findIndex((selectedRow: any)=> selectedRow.id === item.id);
    if(index > -1){
      this.selectedForPurge.splice(index,1);
    }else{
      this.selectedForPurge.push(item)
    }
  }
  generateParams(params: any) {
    const queryParams = [];
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        if (params[key] !== '') {
          if (Array.isArray(params[key])) {
            params[key].forEach((value: string | number | boolean) => {
              let encodeKey = encodeURIComponent(key);
              let encodedvalue = encodeURIComponent(value);
              queryParams.push(encodeKey + '=' + encodedvalue)

            });
          } else {
            let encodeKey = encodeURIComponent(key);
            let encodedvalue = encodeURIComponent(params[key]);
            queryParams.push(encodeKey + '=' + encodedvalue)

          }
        }
      }

    }
    return queryParams.join('&');
  }
  purgeData() {
    let filteredResults = this.selectedForPurge;
    if (filteredResults.length > 0) {
      filteredResults.forEach((x: any) => {
        delete x.checked;
        delete x.deliveryStatusCd;
        delete x.createDate;
        x.destinationName = 'MUNI'
      });
      let f2 = filteredResults.map((x: any) => { return x.citationNumber })
      this.ecitationUserService.purgeRecords(filteredResults).subscribe((data) => {
        this.alertService.success(`Citations purged sucessfully for ${f2.join(", ")}.`);
        this.selectedForPurge = [];
        this.showDetails({ courtNumber: this.selectedCount });
      })
    } else {
        this.alertService.error('Please select at least one citation to perform this action.')
    }
  }

  getCurrentPageTotal() {
    if (this.currentPage * 10 > this.tableData.length) {
      return this.tableData.length
    } else {
      return this.currentPage * 10
    }
  }
}
